import { PlanogramObject } from './PlanogramObject.js';
import { PlanogramSubcomponent } from './PlanogramSubcomponent.js';
import {DividerAttributes} from './Resources.js';

export class PlanogramDivider extends HTMLElement{

    //#region Attributes
    static DividerAttributes = DividerAttributes.DividerAttributes
    //#endregion

    static get observedAttributes() {
        return [ ...Object.values(PlanogramDivider.DividerAttributes) ];
    }

    //#region Attribute Properties
    get x() { return Number(this.getAttribute(PlanogramDivider.DividerAttributes.X)) || 0; }
    get y() { return Number(this.getAttribute(PlanogramDivider.DividerAttributes.Y)) || 0; }
    get z() { return Number(this.getAttribute(PlanogramDivider.DividerAttributes.Z)) || 0; }
    get width() { return Number(this.getAttribute(PlanogramDivider.DividerAttributes.Width)) || 0; }
    get height() { return Number(this.getAttribute(PlanogramDivider.DividerAttributes.Height)) || 0; }
    get depth() { return Number(this.getAttribute(PlanogramDivider.DividerAttributes.Depth)) || 0; }
    get colour() { return PlanogramObject.computeColour(this.getAttribute(PlanogramDivider.DividerAttributes.Colour), 0xffffff); }
    get fillStyle() { return Number(this.getAttribute(PlanogramDivider.DividerAttributes.FillStyle)) || 0; }
    //#endregion

    //#region Private Properties
    firstRender = true;
    #parentSubComponent = null;
    //#endregion

    /** @returns {PlanogramSubcomponent} */
    get parentSubcomponent() { return this.#parentSubComponent; }

    constructor() { super(); }


    //#region Web Component Lifecycle

    /** @returns {number[]} */
    get registryValues(){
        const values = Array(20).fill(0);
        const fills = Array(6).fill(this.colour).flatMap(x=>[x, this.fillStyle]);
        const riser = Array(3).fill(0);
        const options = [this.parentSubcomponent.lineColour,
            this.parentSubcomponent.lineThickness,
            this.parentSubcomponent.transparency,
            this.parentSubcomponent.selected];
        const images = Array(8).fill(-1);
    
        return [...values, ...fills, ...riser, ...options, ...images];
    }

    connectedCallback() {
        if( this.parentElement instanceof PlanogramSubcomponent ){
            this.#parentSubComponent = this.parentElement;
            this.firstRender = false;
            this.#parentSubComponent.dividerPlug();
        }else this.remove();   
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (this.firstRender || oldValue === newValue) return;
        this.#parentSubComponent.dividerPlug();
    }

    disconnectedCallback() { if(this.#parentSubComponent)this.#parentSubComponent.dividerPlug(); }
    //#endregion
}